import React from "react";
import { Modal, Space, Table } from "antd";

const App = ({ isModalOpen, handleOk, handleCancel, selectedDetailRecord }) => {
  // Table Columns
  const columns = [
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
      render: (data) => <Space size="middle">{data}</Space>,
    },
    {
      title: "Address",
      render: (data) => <Space size="middle">{data?.address}</Space>,
    },
    {
      title: "Message",
      render: (data) => (
        <Space size="middle">{selectedDetailRecord?.message}</Space>
      ),
    },
  ];
  return (
    <Modal
      title={selectedDetailRecord?.name}
      open={isModalOpen}
      onOk={handleOk}
      onCancel={handleCancel}
      width={"80%"}
    >
      <Table
        columns={columns}
        dataSource={selectedDetailRecord?.propertyId}
        pagination={false}
        scroll={{ x: 1023 }}
      />
    </Modal>
  );
};

export default App;
